import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useMemo } from "react";
import { FieldType, IFieldValue, InputField } from "veronica-ui-component/dist/component/core";

export const SpecialIndForwarderRefAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();

    const hideSpecialInd = useMemo(() => {
        const allExcludeTypes = ['NP_ODR'];
        const allIncludeTypes = ['CFS', 'VGM', 'MAR', 'COS', 'GS', 'EMP', 'OBS', 'ITM', 'TSS', 'GEN', 'CY', 'YH', 'CC', 'DEM', 'COD', 'COV', 'DOC', 'COO'];
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        if (chargeTypeList.length > 0) {
            const includeTypes = allIncludeTypes;
            includeTypes.push('RADIATION');
            includeTypes.push('XRAY');
            includeTypes.push('HDL');
            const ret = chargeTypeList.some(type => !includeTypes.includes(type));
            const ret2 = chargeTypeList.some(type => allExcludeTypes.includes(type));
            if (ret || ret2) {
                return true;
            } else {
                return false;
            }
        }
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    const hideForwarderReference = useMemo(() => {
        const allExcludeTypes = ['NP_ODR'];
        const allIncludeTypes = ['CFS', 'VGM', 'MAR', 'COS', 'GS', 'EMP', 'OBS', 'ITM', 'TSS', 'GEN', 'CY', 'YH', 'CC', 'DEM', 'COD', 'COV', 'DOC', 'TSS', 'COO'];
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        if (chargeTypeList.length > 0) {
            const includeTypes = allIncludeTypes;
            includeTypes.push('CYVC');
            const ret = chargeTypeList.some(type => !includeTypes.includes(type));
            const ret2 = chargeTypeList.some(type => allExcludeTypes.includes(type));
            if (ret || ret2) {
                return true;
            } else {
                return false;
            }
        }
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                {!hideSpecialInd &&
                    <div className='im-flex-row-item' style={{ width: "150px" }}>
                        <NbisCommonField
                            errorMessages={{}}
                            isReadOnly={false}
                            isShowOptional={false}
                            readOnlyValue={chargeBatchUpdate.specialInd ?? ""}
                            fieldValue={chargeBatchUpdate.specialInd}
                            fieldLabel={"Special Ind"}
                            isSaveClicked={false}
                            fieldType={FieldType.DROPDOWN}
                            fieldKey={'specialInd'}
                            maxLength={60}
                            options={chargeDetailState.dynamicOptions.specialIndDropdownOptions}
                            requiredFieldList={[]}
                            onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                                chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                    </div>}
                {!hideForwarderReference &&
                    <div className='im-flex-row-item'>
                        <InputField
                            label='Forwarder Reference.'
                            disabled={false}
                            width='150px'
                            type="text"
                            value={chargeBatchUpdate.forwarderReference || ''}
                            onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'forwarderReference', chargeBatchUpdate, 'chargeBatchUpdate')}
                            allowedSpecialChars={'all'} />
                    </div>}

            </div>
        </>
    )
}